import { render, staticRenderFns } from "./CustomMetadataUserSelector.vue?vue&type=template&id=36e04df9&lang=pug"
import script from "./CustomMetadataUserSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMetadataUserSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports